import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Submits the laboratory order template and returns Healthlink's Integrated
// Browser URL (KIN-1390).
//
// The template is not the order: it carries the patient and the destination only.
// The GP chooses the tests, clinical details, specimen and priority in Healthlink's
// own form at the returned URL, and the order does not exist until they do.
//
// skipGlobalError because each failure needs its own answer — patient data to fix
// (400), a stale laboratory list to reselect (409), a Healthlink refusal to report
// (422). The caller maps them with utils/labOrderErrors.
export const useSubmitLabOrderTemplate = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async ({ patientId, hospitalId, agencyCode, orderingStaffId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/lab-orders/template`,
        {
          patientId,
          hospitalId,
          agencyCode,
          // The GP whose Medical Council Number goes on the order (KIN-2100). Sent
          // only when it isn't the signed-in user, who the backend reads from the
          // token — see utils/orderingGps.
          ...(orderingStaffId ? { orderingStaffId } : {}),
        }
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["labOrdersList"] });
    },
  });
};
